
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import axios from 'axios';

const API_URL = 'auth/login/';

export const loginUser = createAsyncThunk(
    'auth/loginUser',
    async ({ email, password }, thunkAPI) => {
        try {
            const response = await axios.post(API_URL, {
                email,
                password,
            });

            return response.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response || 'Login failed'
            );
        }
    }
);

export const refreshAccessToken = createAsyncThunk(
    'auth/refreshAccessToken',
    async (_, thunkAPI) => {
        const { refreshToken } = thunkAPI.getState().auth;

        try {
            const response = await axios.post('auth/refresh/', {
                refresh_token: refreshToken,
            });

            return response.data?.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || 'Token refresh failed'
            );
        }
    }
);



const initialState = {
    user: null,
    token: null,
    refreshToken: null,
    tokenExpiry: null,
    isLoading: false,
    isAuthenticated: false,
    error: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: (state) => {
            state.user = null;
            state.token = null;
            state.refreshToken = null;
            state.tokenExpiry = null;
            state.isAuthenticated = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                const expiresInSeconds = parseInt(action.payload.expiresIn, 10);
                const expiryTime = Date.now() + expiresInSeconds * 1000;
                state.isLoading = false;
                state.user = action.payload;
                state.token = action.payload.idToken;
                state.refreshToken = action.payload.refreshToken;
                state.tokenExpiry = expiryTime;
                state.isAuthenticated = true;
                state.error = null;
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || 'Something went wrong';
            })

            .addCase(refreshAccessToken.fulfilled, (state, action) => {
                const expiresInSeconds = parseInt(action.payload.expiresIn, 10);
                const expiryTime = Date.now() + expiresInSeconds * 1000;
                state.token = action.payload.idToken;
                state.tokenExpiry = expiryTime;
                state.isAuthenticated = true;
                state.refreshToken = action.payload.refreshToken
            })
            .addCase(refreshAccessToken.rejected, (state) => {
                state.token = null;
                state.refreshToken = null;
                state.tokenExpiry = null;
                state.user = null;
                state.isAuthenticated = false;
                state.user = null
            })

    },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
